var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnPick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.5V4H40L36 13.5L40 21.5H0Z",
    fill: "#FF7878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65527 17H8.2666V14.4648H9.66309C11.457 14.4648 12.4883 13.396 12.4883 11.8438C12.4883 10.313 11.4731 9.22266 9.70605 9.22266H6.65527V17ZM8.2666 13.165V10.5439H9.40527C10.3613 10.5493 10.8286 11.0703 10.8232 11.8438C10.8286 12.6279 10.3613 13.165 9.40527 13.165H8.2666ZM15.1201 9.22266H13.5088V17H15.1201V9.22266ZM21.6299 11.9297H23.2627C23.0479 10.1411 21.6943 9.11523 19.9004 9.11523C17.8486 9.11523 16.2803 10.5708 16.2803 13.1113C16.2803 15.6411 17.8218 17.1074 19.9004 17.1074C21.877 17.1074 23.0854 15.7969 23.2627 14.3574L21.6299 14.3467C21.4741 15.1899 20.8081 15.6733 19.9219 15.6787C18.7349 15.6733 17.9238 14.7871 17.9238 13.1113C17.9238 11.4731 18.7241 10.5493 19.9326 10.5439C20.8403 10.5493 21.501 11.0703 21.6299 11.9297ZM24.3906 17H26.002V14.7764L26.8184 13.7881L28.9775 17H30.9111L27.9785 12.7031L30.8789 9.22266H28.9346L26.1094 12.6709H26.002V9.22266H24.3906V17Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPick);
export default __webpack_public_path__ + "static/media/icn_pick.f1b4ba18.svg";
export { ForwardRef as ReactComponent };